export interface ChatMessage {
    id?: string;
    text: string;
    sender: 'user' | 'assistant';
    timestamp: Date;
    sessionId?: string;
    metadata?: MessageMetadata;
}

export interface MessageMetadata {
    sources?: Array<{
        content: string;
        metadata?: Record<string, string | number | boolean>;
    }>;
    [key: string]: unknown;
}

export interface ChatSession {
    id: string;
    name: string;
    created_at: string;
    updated_at: string;
    organization_id: string;
    user_id: string;
    rag_application_id: string;
    firstMessage?: string;
    metadata?: Record<string, string | number | boolean>;
    isNew?: boolean; // Added this flag
}

export interface ServerChatSession {
    id: string;
    name: string;
    created: string;
    organization_id: string;
    user_id: string;
    rag_application_id: string;
    metadata?: Record<string, string | number | boolean>;
}

export interface ChatResponse {
    messages: ChatMessage[];
    session?: ServerChatSession;
}

export interface NewSessionRequest {
    name: string;
    metadata?: Record<string, string | number | boolean>;
}

export interface SendMessageRequest {
    message: ChatMessage;
    history: ChatMessage[];
}

// Utility function to map server session to client session
export function mapServerSessionToClient(serverSession: ServerChatSession): ChatSession {
    return {
        id: serverSession.id,
        name: serverSession.name,
        created_at: serverSession.created,
        updated_at: serverSession.created, // Server doesn't send updated_at
        organization_id: serverSession.organization_id,
        user_id: serverSession.user_id,
        rag_application_id: serverSession.rag_application_id,
        metadata: serverSession.metadata,
        firstMessage: '', // Initialize empty, will be populated later
        isNew: true // Initialize new sessions with isNew flag
    };
}